import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import { authUser } from "./fake-db";
import {
  ListItemIcon,
  ListItemText,
  ThemeProvider,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RepeatOutlinedIcon from "@mui/icons-material/RepeatOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import Div from "@jumbo/shared/Div";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import EditCompanyModel from "app/pages/MyBranches/EditCompanyName";

const AuthUserDropdown = () => {
  const navigate = useNavigate();
  const { theme } = useJumboTheme();
  const { userData } = useSelector((state) => state?.userReducer);
  const user = userData?.current_data;
  const [open, setOpen] = useState(false);
  const onLogout = () => {
    Cookies.remove("offline_isAuthenticate");
    Cookies.remove("offline_user_id");
    Cookies.remove("offline_token");
    navigate("/");
    window.location.reload();
  };

  return (
    <ThemeProvider theme={theme}>
      <JumboDdPopover
        triggerButton={
          <Avatar
            src={authUser.profile_pic}
            sizes={"small"}
            sx={{ boxShadow: 25, cursor: "pointer" }}
          />
        }
      >
        <Div
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            minWidth: "310px",
            p: (theme) => theme.spacing(2.5),
          }}
        >
          <Avatar
            src={authUser.profile_pic}
            alt={user?.username?.split(" ")?.[0]}
            sx={{ width: 60, height: 60, mb: 2, textTransform: "capitalize" }}
          />
          <Typography variant={"h5"} sx={{ textTransform: "capitalize" }}>
            {user?.username}
          </Typography>
          <Typography
            variant={"body1"}
            color="text.secondary"
            sx={{ textTransform: "capitalize" }}
          >
            {user?.company_name}
          </Typography>
        </Div>
        <Divider />
        <nav>
          <List disablePadding sx={{ pb: 1 }}>
            <ListItemButton onClick={() => {
              setOpen(true)
            }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <PersonOutlineIcon />
              </ListItemIcon>
              <ListItemText primary="Profile" sx={{ my: 0 }} />
            </ListItemButton>
            {/* <ListItemButton>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <EditOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Edit Profile" sx={{ my: 0 }} />
            </ListItemButton> */}
            <ListItemButton onClick={onLogout}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" sx={{ my: 0 }} />
            </ListItemButton>
          </List>
        </nav>
      </JumboDdPopover>
      {
        open && <EditCompanyModel open={open} setOpen={setOpen} companyData={{ ...userData?.current_data }} />
      }
    </ThemeProvider>
  );
};

export default AuthUserDropdown;
